import { Params } from '@angular/router';

export const EXTERNAL_URL_ROUTE = {
  name: 'externalurl',
  DEFAULT: '',
  route(): string[] {
    return ['/' + this.name];
  },
  CUSTOM: {
    name: ':customUrl',
    route(customUrl: string): string[] {
      return [...EXTERNAL_URL_ROUTE.route(), customUrl];
    }
  },
};
